<template>
    <div>
        <q-card class="shadow-0">
            <q-card-section class="row justify-between">
                <div class="text-h6">Datos Fiscales</div>
                <q-btn outline icon="save" label="Guardar" color="primary" class="q-mr-sm"
                    @click="guardarDatosFiscales()" />
            </q-card-section>
            <q-separator />
            <q-card-section>
                <div class="row q-col-gutter-md">
                    <div class="col-12">
                        <q-input dense outlined v-model="datos.rfc" label="RFC" />
                    </div>
                    <div class="col-12">
                        <q-input dense outlined v-model="datos.razon_social"
                            label="Razón Social  o Nombre de la Persona" />
                    </div>
                    <div class="col-12">
                        <q-input dense outlined v-model="datos.cp" label="Código Postal" />
                    </div>
                    <div class="col-12">
                        <q-select dense class="full-width" outlined fill-input v-model="datos.usoCfdi"
                            :options="usoCfdiStore" label="Uso del CFDI" option-label="usoCfdi" />
                    </div>
                    <div class="col-12" v-if="ValidaRegimen != ''">
                        <q-select dense class="full-width" outlined fill-input v-model="datos.regimen_fiscal"
                            :options="regimenFiscal" label="Régimen Fiscal" option-label="regimenFiscal" />
                    </div>
                    <div class="col-12">
                        <q-select dense class="full-width" outlined fill-input v-model="datos.metodoPago"
                            :options="metodoPagoStore" label="Metodo de Pago" option-label="metodoPago" />
                    </div>
                    <div class="col-12">
                        <q-select dense class="full-width" outlined fill-input v-model="datos.formaPago"
                            :options="formaPagoStore" label="Forma de Pago" option-label="formaPago" />
                    </div>
                    <div class="col-12">
                        <q-select dense class="full-width" outlined fill-input v-model="datos.moneda"
                            :options="monedaStore" label="Moneda" option-label="moneda" />
                    </div>
                </div>
            </q-card-section>
        </q-card>
    </div>
</template>

<script>
import { QSpinnerClock } from 'quasar'
import axios from 'axios'
export default {
    name: 'DatosGenerales',
    data() {
        return {
            datos: {
                _id: '',
                _id_cliente: '',
                rfc: '',
                razon_social: '',
                cp: '',
                usoCfdi: {
                    usoCfdi: ''
                },
                regimen_fiscal: {
                    regimenFiscal: ''
                },
                metodoPago: {
                    metodoPago: ''
                },
                formaPago: {
                    formaPago: ''
                },
                moneda: {
                    moneda: ''
                }
            },

            regimenFiscalStore: [],
            formaPagoStore: [],
            metodoPagoStore: [],
            usoCfdiStore: [],
            regimenFiscal: [],
            monedaStore: [],
        };
    },
    computed: {
        usuarioStore() {
            return this.$store.state.auth.usuario;
        },

        ValidaRegimen() {
            let rfc = this.datos.rfc
            console.log(rfc.length)
            if (rfc.length === 12) {
                this.regimenFiscal = [];
                let filtroRegimen = this.regimenFiscalStore.filter(f => f.moral === 'Sí');
                this.regimenFiscal = [...filtroRegimen]
                console.log('m', this.regimenFiscal)
                return 'M';
            } else if (rfc.length === 13) {
                this.regimenFiscal = [];
                let filtroRegimen = this.regimenFiscalStore.filter(f => f.fisica === 'Sí');
                this.regimenFiscal = [...filtroRegimen]
                console.log('f', this.regimenFiscal)
                if (rfc === 'XAXX010101000' || rfc === 'XEXX010101000') {
                    let b = filtroRegimen.find(f => f.clave === '616');
                    this.regimen_fiscal = b;
                }
                return 'F';
            }
            return "";
        },
    },
    created() {
        this.GetRegimenFiscal();
        this.GetUsoCfdi();
        this.GetMetodoPago();
        this.GetFormaPago();
        this.GetMoneda();
    },
    methods: {
        async guardarDatosFiscales() {
            if (this.datos.rfc == '' || this.datos.razon_social == '' || this.datos.cp == '' || this.datos.usoCfdi.usoCfdi == '' || this.datos.regimen_fiscal.regimenFiscal == '' || this.datos.metodoPago.metodoPago == '' || this.datos.formaPago.formaPago == '' || this.datos.moneda.moneda == '') {
                this.$q.notify({ type: 'negative', position: 'top-right', message: 'Ingrese todos los datos del formulario.' })
                return
            }
            this.datos._id_cliente = this.usuarioStore._id
            console.log(this.datos)
            this.$q.loading.show({ spinner: QSpinnerClock, spinnerColor: 'white', spinnerSize: 90, message: 'Guardando información. Espere...', messageColor: 'white' })
            try {
                await axios.post('Configuracion/PostDatosFiscales', this.datos)
                this.$q.loading.hide()

                this.$q.notify({ type: 'positive', position: 'top-right', message: 'Datos guardados correctamente' })
            } catch (err) {
                this.$q.loading.hide()
                this.$q.notify({ type: 'negative', position: 'top-right', message: 'Error al actualizar perfil' })
            }
        },
        async obtenerPerfil() {
            try {
                const res = await axios.get('Configuracion/GetDatosFiscalesPorId/' + this.usuarioStore._id)

                if (res.data) {
                    this.datos = res.data
                }
                console.log('res.data', res.data)
            } catch (err) {
                console.error('Error al obtener perfil:', err)
            }
        },
        async GetRegimenFiscal() {
            if (this.regimenFiscalStore.length == 0) {
                try {
                    let response = await axios.get("https://api-beta-erp.contago.com.mx/api/CatalogosSat/GetCatRegimenFiscalAsync/");
                    console.log('d', response.data)
                    this.regimenFiscalStore = response.data;
                } catch (error) {
                    console.log(error);
                }
            }
        },

        async GetUsoCfdi() {
            if (this.usoCfdiStore.length != 0) {
                return;
            } else {
                try {
                    let response = await axios.get('https://api-beta-erp.contago.com.mx/api/CatalogosSat/GetCatUsoCfdiAsync')
                    let x = response.data;
                    this.usoCfdiStore = [...x]
                } catch (error) {
                    console.log(error)
                }
            }
        },

        async GetMetodoPago() {
            if (this.metodoPagoStore.length != 0) {
                return;
            } else {
                try {
                    let response = await axios.get('https://api-beta-erp.contago.com.mx/api/CatalogosSat/GetCatMetodoPagoAsync')
                    let x = response.data;
                    this.metodoPagoStore = [...x]
                } catch (error) {
                    console.log(error)
                }
            }
        },

        async GetFormaPago() {
            if (this.formaPagoStore.length != 0) {
                return;
            } else {
                try {
                    let response = await axios.get('https://api-beta-erp.contago.com.mx/api/CatalogosSat/GetCatFormaPagoAsync')
                    let x = response.data;
                    this.formaPagoStore = [...x]
                } catch (error) {
                    console.log(error)
                }
            }
        },

        async GetMoneda() {
            if (this.monedaStore.length != 0) {
                return;
            } else {
                try {
                    let response = await axios.get('https://api-beta-erp.contago.com.mx/api/CatalogosSat/GetCatMonedaAsync')
                    let x = response.data;
                    this.monedaStore = [...x]
                } catch (error) {
                    console.log(error)
                }
            }
        },
    },
    mounted() {
        this.obtenerPerfil()
    },
};
</script>